// extracted by mini-css-extract-plugin
export var icon = "_5d-1";
export var subtext = "_5d-0";